<si-split orientation="horizontal" stateId="split-mixed" [sizes]="[60, 40]" class="padding-bottom-20">
  <!-- Editor -->

  <si-split-part stateId="code-editor" scale="auto" class="bg-base-1" collapseDirection="end"
    [showHeader]="false"
    [class.is-executing]="codeEditorData?.isFinalCodeExecuting">

    <!-- Editor Tabs (Automation and Support) with Vertical Split inside -->
    <app-tabset [tabs]="editorTabs" (tabChanged)="onEditorTabChanged($event)"
      [actions]="currentEditorTabIndex === 0
        ? [{ iconClass: 'element-copy', tooltip: 'Copy Code', click: handleCopyAction }, { iconClass: 'element-play', tooltip: 'Execute Code', click: handleExecuteAction, disabled: codeEditorData?.isFinalCodeExecuting }]
        : [{ iconClass: 'element-copy', tooltip: 'Copy', click: handleCopyAction }]">
      <si-split *ngIf="splitReady" orientation="vertical" stateId="vertical-split">
        <!-- Top Part: Editor Content (changes based on selected tab) -->
        <si-split-part scale="auto" stateId="middle-top" [showHeader]="false">
          <app-editor-automation-hub *ngIf="currentEditorTabIndex === 0" [code]="finalCode"
            (codeChange)="onFinalCodeChange($event)">
          </app-editor-automation-hub>

          <app-editor-support-hub *ngIf="currentEditorTabIndex === 1" [executeCommandList]="executeCommandList">
          </app-editor-support-hub>
        </si-split-part>

        <!-- Bottom Part: Result Tabs (Insights and Feed) -->
        <!-- showHeader=isResultsCollapsed: the built-in header strip acts as the expand placeholder when collapsed -->
        <si-split-part #middleBottom *ngIf="currentEditorTabIndex === 0" collapseDirection="end" scale="none" stateId="middle-bottom"
          [showHeader]="isResultsCollapsed"
          (collapseChanged)="onResultsCollapseChanged($event)">
          <app-tabset [tabs]="displayResultTabs" (tabChanged)="onResultTabChanged($event)"
            [isCollapsed]="isResultsCollapsed"
            [onToggleCollapse]="toggleResultsPanel">
            <app-insights *ngIf="currentResultTabIndex === 0" [finalResponse]="insightsContent"
              [isExecuting]="codeEditorData?.isFinalCodeExecuting" [errorMessage]="streamingData?.submitCodeError"
              [isUserSubmitted]="isUserSubmitted">
            </app-insights>

            <app-feed *ngIf="currentResultTabIndex === 1" [finalResponse]="codeEditorData?.finalResponse"
              [isExecuting]="codeEditorData?.isFinalCodeExecuting" [errorMessage]="streamingData?.submitCodeError"
              [isUserSubmitted]="isUserSubmitted">
            </app-feed>
          </app-tabset>
        </si-split-part>
      </si-split>
    </app-tabset>
  </si-split-part>

  <!-- Chat -->
  <si-split-part #chatPanel collapseDirection="end" scale="auto" class="bg-base-1"
    [showHeader]="isChatCollapsed"
    (collapseChanged)="onChatCollapseChanged($event)">
    <app-tabset [tabs]="chatTabs" [selectedTabIndex]="currentChatTabIndex"
      [isCollapsed]="isChatCollapsed"
      [onToggleCollapse]="toggleChatPanel"
      collapseOrientation="horizontal">
      <app-chat-copilot [executeCommandList]="executeCommandList" [inputMessageText]="inputMessageText"
        [isStreaming]="isStreaming" [chatAttachments]="chatAttachments" [isElectronMode]="isElectronMode"
        [psseVersions]="psseVersions" [selectedPsseVersion]="selectedPsseVersion"
        [isPsseDropdownDisabled]="isPsseDropdownDisabled || isStreaming"
        (messageTextChange)="inputMessageText = $event" (messageSend)="sendMessage()"
        (codeChange)="onFinalCodeChange($event)" (feedbackSend)="sendFeedback($event.cmd, $event.value)"
        (attachFilesClick)="attachFiles()" (removeFileClick)="removeFile($event)"
        (psseVersionChange)="onPsseVersionChange($event)"
        (stopWorkflow)="onStopWorkflow()">
      </app-chat-copilot>
    </app-tabset>
  </si-split-part>
</si-split>
